export const Currenttab_home="Currenttab_home";
export const Currenttab_About="Currenttab_About";
export const Currenttab_joinme="Currenttab_joinme";
export const Currenttab_learn="Currenttab_learn";
export const Currenttab_Games="Currenttab_Games";